import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';

// 全局错误捕获
window.addEventListener('error', (event) => {
  console.error('[Global Error Handler] Uncaught error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
  // 不阻止默认行为，让 ErrorBoundary 也能捕获
});

// 全局 Promise rejection 捕获
window.addEventListener('unhandledrejection', (event) => {
  console.error('[Global Error Handler] Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise,
    error: event.reason instanceof Error ? {
      message: event.reason.message,
      stack: event.reason.stack
    } : event.reason
  });
  // 不阻止默认行为，但记录详细信息
});

// 页面卸载前记录
window.addEventListener('beforeunload', () => {
  console.log('[Global] Page unloading');
});

// 页面可见性变化记录
document.addEventListener('visibilitychange', () => {
  console.log('[Global] Visibility changed:', {
    hidden: document.hidden,
    visibilityState: document.visibilityState
  });
});

// 暂时关闭 StrictMode：开发环境下会双重挂载，可能导致机构请求/状态错乱并引发白屏
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
); 